import { useState } from 'react'

import { cn } from '@/lib/utils.ts'

import { Button } from '@/components/ui/button.tsx'

type Props = {
  label: string
  value: string | null
  disabled?: boolean
  defaultImgSrc?: string
  copiedImgSrc?: string
}

export const CopyButton = ({ label, value, disabled, defaultImgSrc, copiedImgSrc }: Props) => {
  const [isCopied, setIsCopied] = useState(false)

  return (
    <div className="flex items-center w-full">
      <div
        className={cn(
          'h-5 flex items-center gap-1 px-[3px] py-0.5 min-w-0 flex-1 rounded-l-xs border border-r-0',
          value || disabled
            ? 'bg-surface-background border-border-default-secondary'
            : 'bg-surface-backgroundElevated border-border-default-neutral',
        )}
      >
        <span
          className={cn('text-contents-disabled leading-3 font-EN-KR-tag-bold flex-shrink-0', {
            'text-contents-secondary': value || disabled,
          })}
        >
          {label}
        </span>
        <span className="text-contents-primary font-EN-KR-tag-regular truncate">{disabled ? '' : value}</span>
      </div>

      <Button
        type="button"
        variant="icon"
        size="icon"
        disabled={disabled}
        className="rounded-[0px_4px_4px_0px] flex-shrink-0"
        onClick={() => {
          // biome-ignore lint/style/noNonNullAssertion: This is guaranteed to be non-null
          navigator.clipboard.writeText(value!).then(() => {
            setIsCopied(true)
            setTimeout(() => setIsCopied(false), 400)
          })
        }}
      >
        <img
          src={isCopied ? copiedImgSrc : defaultImgSrc}
          alt={isCopied ? 'copied' : 'copy'}
          className="transition-all duration-200"
        />
      </Button>
    </div>
  )
}
